<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol style="padding-right:4px" sm="3">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="3">
                    <input type="text" placeholder="Header" v-model="searchHeader" class="form-control"/>
                </CCol>
                <CCol sm="2" style="padding-right:4px;padding-left:4px">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="tanggalMulai" class="form-control"/>
                </CCol>
                <CCol sm="2" style="padding-right:4px;padding-left:4px">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="tanggalSelesai" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="3">
                    </CCol>
                    <CCol sm="6">
                        <CCard class="cards-message" :style="setBackground">
                            <CRow>
                                <CCol sm="9" class="text-left title-message">
                                    <span class="font-weight-bold" v-if="header == '' || header == 'null'">Place Title</span>
                                    <span class="font-weight-bold" v-if="header != ''">{{header}}</span>
                                </CCol>
                                <CCol sm="3" class="text-right">
                                    <!-- <span v-if="tglCreated == '' || tglCreated == 'null'">{{thisDate}}</span> -->
                                    <span>{{separatorDate(tglCreated)}}</span>
                                </CCol>
                            </CRow>
                            <CRow class="mt-3">
                                <CCol sm="12" class="text-left">
                                    <span class="font-weight-bolder" style="font-size:16px" v-if="isHtml.value == '' ">Place Message</span>
                                    <span class="font-weight-bolder" style="font-size:16px" v-if="isHtml.value == 'N'">{{pesan}}</span>
                                    <p v-if="isHtml.value == 'Y'" v-html="html">{{html}}</p>
                                </CCol>
                            </CRow>
                            <CRow class="mt-3">
                                <CCol sm="12" class="text-right">
                                    <span v-if="namaPegawai == '' || namaPegawai == 'null'">{{namaLogin}}</span>
                                    <span v-if="namaPegawai != '' || namaPegawai != 'null'">{{namaPegawai}}</span>
                                </CCol>
                            </CRow>
                        </CCard>
                    </CCol>
                    <CCol sm="3">
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Title</label>
                        <input 
                            class="form-control "
                            v-model.trim="$v.header.$model"
                            :class="{ 'is-invalid':$v.header.$error, 'is-valid': !$v.header.$invalid }"
                            placeholder="Title"
                            maxlength="100"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>URL</label>
                        <input 
                            class="form-control "
                            v-model="url"
                            placeholder="URL"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <label>Tipe Pegawai</label>
                            </div>
                            <div class="col-6">
                                <input type="checkbox" v-model="allCheck" id="all" @change="checkAll()">
                                <label :for="all" class="ml-2" style="color:black">Semua</label>
                            </div>
                            <div class="col-6" v-for="(item, id) in dataTipePegawai" :key="id">
                                <input :disabled="flag==true" type="checkbox" :id="item.value" :name="item.value" v-model="item.checked" :value="item.value">
                                <label :for="item.value" class="ml-2" style="color:black">{{item.text}}</label>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Background</label>
                        <CRow>
                            <CCol sm="2">
                                <CButton @click="backgroundCard('#83a6eb')" style="background-color:#83a6eb;padding:16px;border-radius:50%"></CButton>
                            </CCol>
                            <CCol sm="2">
                                <CButton @click="backgroundCard('#306bdd')" style="background-color:#306bdd;padding:16px;border-radius:50%"></CButton>
                            </CCol>
                            <CCol sm="2">
                                <CButton @click="backgroundCard('#1ec1c3')" style="background-color:#1ec1c3;padding:16px;border-radius:50%"></CButton>
                            </CCol>
                            <CCol sm="2">
                                <CButton @click="backgroundCard('#fc8f6e')" style="background-color:#fc8f6e;padding:16px;border-radius:50%"></CButton>
                            </CCol>
                            <CCol sm="2">
                                <CButton @click="backgroundCard('#f96f8c')" style="background-color:#f96f8c;padding:16px;border-radius:50%"></CButton>
                            </CCol>
                            <CCol sm="2">
                                <CButton @click="backgroundCard('#8f81fe')" style="background-color:#8f81fe;padding:16px;border-radius:50%"></CButton>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tanggal Mulai</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tglMulai.$model"
                            :class="{ 'is-invalid':$v.tglMulai.$error, 'is-valid': !$v.tglMulai.$invalid }"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Selesai</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tglSelesai.$model"
                            :class="{ 'is-invalid':$v.tglSelesai.$error, 'is-valid': !$v.tglSelesai.$invalid }"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Push Notification</label>
                        <model-select :options="dataIsPushNotification"
                            class="form-control model-select"
                            v-model.trim="$v.isPushNotif.$model"
                            :class="{ 'is-invalid select-invalid':$v.isPushNotif.$error, 'is-valid select-valid': !$v.isPushNotif.$invalid }"
                            placeholder="Pilih Push Notification">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Tampilkan Pesan</label>
                        <model-select :options="dataTampilkan"
                            class="form-control model-select"
                            v-model.trim="$v.tampilkan.$model"
                            :class="{ 'is-invalid select-invalid':$v.tampilkan.$error, 'is-valid select-valid': !$v.tampilkan.$invalid }"
                            placeholder="Pilih Tampilkan Pesan">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Mode Pesan</label>
                        <model-select :options="dataIsHtml"
                            class="form-control model-select"
                            v-model.trim="$v.isHtml.$model"
                            :class="{ 'is-invalid select-invalid':$v.isHtml.$error, 'is-valid select-valid': !$v.isHtml.$invalid }"
                            placeholder="Pilih Mode Pesan">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12" v-if="isHtml.value == 'Y'">
                        <label>HTML Code</label>
                        <vue-editor 
                            v-model.trim="$v.html.$model"
                            :class="{ 'is-invalid':$v.html.$error, 'is-valid': !$v.html.$invalid }"
                            :editorToolbar="customToolbar"
                            placeholder="Masukkan Pesan"
                        ></vue-editor>
                    </CCol>
                    <CCol sm="12" v-if="isHtml.value == 'N'">
                        <label>Pesan Deskripsi</label>
                        <textarea 
                            class="form-control textarea" 
                            maxlength="1000"
                            v-model.trim="$v.pesan.$model"
                            :class="{ 'is-invalid':$v.pesan.$error, 'is-valid': !$v.pesan.$invalid }"
                            placeholder="Deskripsi Pesan"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Bidang</label>
                        <div class="autocomplete">
                            <input type="text"
                                class="form-control"
                                v-if="allBidang == false"
                                @click="toggleVisibleUnit()"
                                @blur="toggleCloseVisibleUnit()"
                                v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                v-model="queryUnit"
                                @keydown.up="upUnit"
                                @keydown.down="downUnit"
                                @keydown.enter="selectItemUnit"
                                placeholder="Pilih Unit Level"
                            >
                            <input type="text"
                                class="form-control"
                                disabled
                                v-else
                                style="background-color: rgba(249, 250, 252, 1)"
                                v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                v-model="queryUnit"
                                placeholder="Pilih Unit Level"
                            >
                            <div class="popovers" v-show="visibleUnit">
                                <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesUnit"
                                        :key="index"
                                        :class="{ 'selected': (selectedUnit == index)}"
                                        @click="itemClickedUnit(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                        <div>
                            <input type="checkbox" v-model="allBidang" id="allBidang" @change="checkBidang()">
                            <label :for="allBidang" class="ml-2" style="color:black">Semua Bidang</label>
                        </div>
                    </CCol>
                    <CCol sm="6" v-if="tempUnit.length != 0 && tipe == 'C'">
                        <label>Daftar Bidang</label>
                        <ul class="list-group">
                            <li class="list-group-item" v-for="(li,id) in tempUnit" :key="id">
                                <CRow>
                                    <CCol sm="10">{{li.text}}</CCol>
                                    <CCol sm="2"><img :src="closeIcon" style="cursor:pointer;float:right" @click="removeUnit(id)" width="20px" height="20px"/></CCol>
                                </CRow>
                            </li>
                        </ul>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit mt-5">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tablePesan'
import {DataApi} from "../../../service/DataApi";
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { ModelSelect } from 'vue-search-select'
import { validationMixin } from 'vuelidate'
import { VueEditor } from "vue2-editor";
export default {
    components: {
        Tables,
        ModelSelect,
        VueEditor
    },
    mixins: [validationMixin],
    validations: {
        header: {
            required
        },
        tglMulai: {
            required
        },
        tglSelesai: {
            required
        },
        html: {
            required
        },
        pesan: {
            required
        },
        isPushNotif: {
            value: {
                required
            },
            text: {
                required
            }
        },
        isHtml: {
            value: {
                required
            },
            text: {
                required
            }
        },
        tampilkan: {
            value: {
                required
            },
            text: {
                required
            }
        },
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            // data search unit
            dataUnit: [],
            titleUnit:"Pilih Unit Level",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnits: '',

            // data search Tipe Pegawai
            dataTipePegawai: [],
            titleTipePegawai:"Pilih Tipe Pegawai",
            selectedItemTipePegawai: null,
            selectedTipePegawai: 0,
            queryTipePegawai: '',
            visibleTipePegawai: false,
            kodeTipePegawai: '',

            success: true,
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama', 'Header', 'Pesan/HTML', 'Created Date', 'Periode', 'Status', 'Action'],
            dataTd: ['namaPegawai', 'header', 'pesan', 'tglCreated', 'tanggal', 'tampilkan', 'action'],
            styleTable: ['150px', '100px', '170px', '130px', '200px', '100px', '100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            dataIsHtml: [],
            dataIsPushNotification: [],
            dataTampilkan: [],


            // data model
            header: '',
            html: '',
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{ list: "bullet" }]
            ],
            isPushNotif: {
                value: '',
                text: ''
            },
            isHtml: {
                value: '',
                text: ''
            },
            lvl: '',
            namaPegawai: '',
            pesan: '',
            tampilkan: {
                value: '',
                text: ''
            },
            tglCreated: '',
            tglMulai: '',
            tglSelesai: '',
            tipePegawai: '',
            unix: '',
            url: '',
            warna: '',
            warnaFont: '',

            thisDate: new Date(),
            dates: '',
            namaLogin: '',
            setBackground: '',
            tipe: 'C',


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchHeader: '',
            tanggalMulai: '',
            tanggalSelesai: '',

            
            // datas
            datas: [],

            //error
            errorMessage: '',
            tempCheck: [],
            allCheck: false,
            flag: false,

            // tampungan
            tempUnit: [],
            allBidang: false,
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        tanggalMulai() {
            this.flagSearch = true
        },
        tanggalSelesai() {
            this.flagSearch = true
        },
        searchHeader() {
            this.flagSearch = true
        },
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawai = ''
            }
            this.flagSearch = true
            this.getDataPegawai()
        },
        queryUnit() {
            if(this.queryUnit == '') {
                this.idUnits = ''
            }
            this.getDataUnit('null')
        },
        queryTipePegawai() {
            if(this.queryTipePegawai == '') {
                this.kodeTipePegawai = ''
            }
            this.getDataTipePegawai('null')
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
        matchesTipePegawai() {
            if (this.queryTipePegawai == '') {
                return [];
            }
            return this.dataTipePegawai.filter((item) => item['text'].toLowerCase().includes(this.queryTipePegawai.toLowerCase()))
        },
    },
    methods: {
        checkAll() {
            let flag = document.getElementById('all').checked
            this.flag = flag
            if(flag == true) {
                var i = 0
                for(i=0;i<this.dataTipePegawai.length;i++) {
                    this.dataTipePegawai[i].checked = true
                }
            } else {
                var j = 0
                for(j=0;j<this.dataTipePegawai.length;j++) {
                    this.dataTipePegawai[j].checked = false
                }
            }
        },
        checkBidang() {
            if(this.allBidang == true) {
                this.tempUnit = []
                this.queryUnit = ''
                this.idUnits = ''
            }
        },
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaPegawai.toLowerCase() < b.namaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.namaPegawai.toLowerCase() > b.namaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.header.toLowerCase() < b.header.toLowerCase()) {
                        return -1
                    }
                    if (a.header.toLowerCase() > b.header.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.pesan.toLowerCase() < b.pesan.toLowerCase()) {
                        return -1
                    }
                    if (a.pesan.toLowerCase() > b.pesan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.tglCreated.toLowerCase() < b.tglCreated.toLowerCase()) {
                        return -1
                    }
                    if (a.tglCreated.toLowerCase() > b.tglCreated.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.tglMulai.toLowerCase() < b.tglMulai.toLowerCase()) {
                        return -1
                    }
                    if (a.tglMulai.toLowerCase() > b.tglMulai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.tampilkan.toLowerCase() < b.tampilkan.toLowerCase()) {
                        return -1
                    }
                    if (a.tampilkan.toLowerCase() > b.tampilkan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                header: this.searchHeader,
                idPegawai: this.idPegawai,
                limit: this.size,
                pageIn: this.page,
                tglMulai: this.tanggalMulai,
                tglSelesai: this.tanggalSelesai
            }
            DataApi.post("pesan/lihat/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDownload() {
            if(this.datas.length != 0) {
                let payload = {
                    header: this.searchHeader,
                    idPegawai: this.idPegawai,
                    limit: this.totalRow,
                    pageIn: 1,
                    tglMulai: this.tanggalMulai,
                    tglSelesai: this.tanggalSelesai
                }
                DataApi.post("/export/pesan/lihat/backoffice", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Pengumuman')
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.queryPegawai = ''
            this.idPegawai = ''
            this.tanggalMulai = ''
            this.tanggalSelesai = ''
            this.searchHeader = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.header = ''
                this.html = ''
                this.isHtml.value = ''
                this.isHtml.text = ''
                this.isPushNotif.value = ''
                this.isPushNotif.text = ''
                this.tampilkan.value = ''
                this.tampilkan.text = ''
                this.tglMulai = ''
                this.tglSelesai = ''
                this.pesan = ''
                this.unix = ''
                this.url = ''
                this.tipe = 'C'
                this.namaPegawai = ''
                this.queryUnit = ''
                this.idUnits = ''
                this.allBidang = false
                this.tempUnit = []
                this.getDataIsHtml()
                this.getDataTampilkan()
                this.getDataIsPushNotification()
                this.getDataPegawai()
                this.backgroundCard('#83a6eb')
                this.getDataPegawai()
                this.getDataUnit('null')
                this.getDataTipePegawai('null')
                this.allCheck = false
                this.tempCheck = []
                this.flag = false
                let date = this.thisDate
                var month = date.getMonth() + 1
                var day = date.getDate();
                var year = date.getFullYear();

                this.tglCreated = year + "-" + month + "-" + day;
                this.$v.$reset()
            }
        },
        goSave() {
            let data = this.dataTipePegawai
            let tipePegawai = ''
            var i = 0
            let statTrue = ''
            let statFalse
            for(i=0;i<data.length;i++) {
                if(data[i].checked == true) {
                    if(statTrue == '') {
                        statTrue = data[i].value
                    } else {
                        statTrue = data[i].value + ',' + statTrue
                    }
                } else {
                    if(statFalse == '') {
                        statFalse = data[i].value
                    } else {
                        statFalse = data[i].value + ',' + statFalse
                    }
                }
            }
            if(statFalse == '' || this.flag == true) {
                tipePegawai = ''
            } else {
                tipePegawai = statTrue
            }

            let unit = ''
            if(this.tipe == 'C') {
                let dataUnit = this.tempUnit
                if(dataUnit.length != 0) {
                    var j = 0
                    for(j=0;j<dataUnit.length;j++) {
                        if((j+1) == dataUnit.length ) {
                            unit += dataUnit[j].value
                        } else {
                            unit += dataUnit[j].value + '##'
                        }
                    }
                }
            } else {
                unit = this.idUnits
            }
            
            let payload = {
                header: this.header,
                html: this.html,
                isHtml: this.isHtml.value,
                isPushNotif: this.isPushNotif.value,
                lvl: unit,
                pesan: this.pesan,
                tampilkan: this.tampilkan.value,
                tglCreated: this.dates,
                tglMulai: this.tglMulai,
                tglSelesai: this.tglSelesai,
                tipe: this.tipe,
                tipePegawai: tipePegawai,
                unix: this.unix,
                url: this.url,
                warna: this.warna,
                warnaFont: "",
                unit: unit
            }
            DataApi.post("pesan/simpan/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.header = generate.header
            let html = generate.html
            if(html == '' || html == 'null') {
                this.isHtml.value = 'N'
                this.isHtml.text = 'Pesan'
                this.pesan = generate.pesan
                this.html = ''
            } else {
                this.isHtml.value = 'Y'
                this.isHtml.text = 'HTML'
                this.html = generate.html
                this.pesan = ''
            }


            let isPushNotif = generate.isPushNotif
            if(isPushNotif == 'Y') {
                this.isPushNotif.value = 'Y'
                this.isPushNotif.text = 'Yes, Push Notification'
            } else {
                this.isPushNotif.value = 'N'
                this.isPushNotif.text = 'No.'
            }
            this.namaPegawai = generate.namaPegawai
            
            let tampilkan = generate.tampilkan
            if(tampilkan == 'Y') {
                this.tampilkan.value = 'Y'
                this.tampilkan.text = 'Ya, Tampilkan'
            } else {
                this.tampilkan.value = 'N'
                this.tampilkan.text = 'Tidak.'
            }
            this.tglCreated = generate.tglCreated
            this.tglMulai = generate.tglMulai
            this.tglSelesai = generate.tglSelesai
            this.unix = generate.unix
            this.url = generate.url
            this.backgroundCard(generate.warna)
            let tempTipe = generate.tipePegawai
            let datas = this.dataTipePegawai
            if(tempTipe == '') {
                var j = 0
                this.allCheck = true
                for(j=0;j<datas.length;j++) {
                    this.dataTipePegawai[j].checked = true
                    this.flag = true
                }
            } else {
                let tipePegawai = tempTipe.split(',')
                var i = 0
                for(i=0;i<tipePegawai.length;i++) {
                    var k = 0
                    for(k=0;k<datas.length;k++) {
                        if(tipePegawai[i] == datas[k].value) {
                            this.dataTipePegawai[k].checked = true
                        }
                    }
                }
            }

            let unit = generate.lvl
            if(unit == '') {
                this.allBidang = true
                this.queryUnit = ''
                this.idUnits = ''
            } else {
                this.getDataUnit(unit)
            }
            
            this.tipe = 'U'
            this.moving()
        },
        separatorDate(val) {
            let date = val.split("T")[0]
            this.dates = date
            let bulan = date.split("-")[1]
            let month = ''
            if(bulan == "01" || bulan == '1' || bulan == 1) {
                month = 'Jan'
            } else if(bulan == "02" || bulan == '2' || bulan == 2) {
                month = 'Feb'
            } else if(bulan == "03" || bulan == '3' || bulan == 3) {
                month = 'Mar'
            } else if(bulan == "04" || bulan == '4' || bulan == 4) {
                month = 'Apr'
            } else if(bulan == "05" || bulan == '5' || bulan == 5) {
                month = 'Mei'
            } else if(bulan == "06" || bulan == '6' || bulan == 6) {
                month = 'Jun'
            } else if(bulan == "07" || bulan == '7' || bulan == 7) {
                month = 'Jul'
            } else if(bulan == "08" || bulan == '8' || bulan == 8) {
                month = 'Ags'
            } else if(bulan == "09" || bulan == '9' || bulan == 9) {
                month = 'Sep'
            } else if(bulan == "10" || bulan == 10) {
                month = 'Okt'
            } else if(bulan == "11" || bulan == 11) {
                month = 'Nov'
            } else if(bulan == "12" || bulan == 12) {
                month = 'Des'
            }
            return month + ' ' + date.split("-")[2]
        },
        backgroundCard(val) {
            this.setBackground =  'background-color:' + val
            this.warna = val
        },

        getDataIsHtml() {
            this.dataIsHtml = [
                { text: 'HTML' , value: 'Y'},
                { text: 'Pesan' , value: 'N'}
            ]
        },
        getDataIsPushNotification() {
            this.dataIsPushNotification = [
                { text: 'Yes, Push Notification' , value: 'Y'},
                { text: 'No.' , value: 'N'}
            ]
        },
        getDataTampilkan() {
            this.dataTampilkan = [
                { text: 'Ya, Tampilkan' , value: 'Y'},
                { text: 'Tidak.' , value: 'N'}
            ]
        },

        /**
         * VALIDATION DATA
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.pesan != '' || this.html != '') {
                    this.goSave()
                    this.loading = true
                } else {
                    //
                }
            } else {
                //
            }
        },
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        /**
         * SEARCH UNIT LEVEL
         */
        getDataUnit(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    limit: 10,
                    namaUnit: this.queryUnit,
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: ''
                }
            } else {
                payload = {
                    limit: 10,
                    namaUnit: '',
                    pageIn: 1,
                    namaParentUnit: '',
                    idUnit: val
                }
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = ''
                    if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang
                        }                      
                    } else {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                        }
                    }
                    this.dataUnit.push(onPush)
                }
                if(val != 'null') {
                    this.queryUnit = this.dataUnit[0].text
                    this.idUnits = this.dataUnit[0].value
                }
            })
        },
        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.queryUnit = this.selectedItemUnit.text
            this.idUnits = this.selectedItemUnit.value
            if(this.tipe == 'C') {
                var i = 0
                let data = this.tempUnit
                let push = ''
                if(data.length == 0) {
                    push = {
                        text: this.queryUnit,
                        value: this.idUnits
                    }
                    this.tempUnit.push(push)
                } else {
                    var j = 0
                    let status = false
                    for(j=0;j<data.length;j++) {
                        if(data[j].value == this.idUnits) {
                            status = true
                            break
                        } else {
                            status = false
                        }
                    }
                    if(status == false) {
                        push = {
                            text: this.queryUnit,
                            value: this.idUnits
                        }
                        this.tempUnit.push(push)
                    }
                }
                this.queryUnit = ''
                this.idUnits = ''
            }
            this.visibleUnit = false;
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },

        removeUnit(id) {
            this.tempUnit.splice(id, 1)
        },

        /**
         * SEARCH TIPE PEGAWAI
         */
        getDataTipePegawai(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    keterangan: this.queryTipePegawai,
                    limit: 10,
                    pageIn: 1
                }
            } else {
                payload = {
                    keterangan: val,
                    limit: 10,
                    pageIn: 1
                }
            }
            DataApi.post("pegawai/status/lihat", payload)
            .then(res => {
                this.dataTipePegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].kode,
                        text: tempData[i].keterangan,
                        checked: false
                    }
                    this.dataTipePegawai.push(onPush)
                }
            })
            if(val != 'null') {
                this.queryTipePegawai = this.dataTipePegawai[0].text
                this.kodeTipePegawai = this.dataTipePegawai[0].value
            }
        },
        toggleVisibleTipePegawai() {
            this.visibleTipePegawai = true;
        },
        hideTipePegawai() {
            this.visibleTipePegawai = false;
        },
        toggleCloseVisibleTipePegawai() {
            setTimeout(this.hideTipePegawai, 1000);
        },
        itemClickedTipePegawai(index) {
            this.selectedTipePegawai = index;
            this.selectItemTipePegawai();
        },
        itemClickedTipePegawaiBefore(index) {
            this.selectedTipePegawai = index;
            this.selectedItemTipePegawai = this.dataTipePegawai[this.selectedTipePegawai];
            this.kodeTipePegawai = this.selectedItemTipePegawai.value
            this.queryTipePegawai = this.selectedItemTipePegawai.text
            this.visibleTipePegawai = false;
        },
        selectItemTipePegawai() {
            if (!this.matchesTipePegawai.length) {
            return;
            }
            this.selectedItemTipePegawai = this.matchesTipePegawai[this.selectedTipePegawai];
            this.visibleTipePegawai = false;
            this.kodeTipePegawai = this.selectedItemTipePegawai.value
            this.queryTipePegawai = this.selectedItemTipePegawai.text
            if (this.shouldReset) {
            this.queryTipePegawai = '';
            this.selectedTipePegawai = 0;
            }
        },
        upTipePegawai() {
            if (this.selectedTipePegawai == 0) {
            return;
            }
            this.selectedTipePegawai -= 1;
            this.scrollToItemTipePegawai();
        },
        downTipePegawai() {
            if (this.selectedTipePegawai >= this.matchesTipePegawai.length - 1) {
            return;
            }
            this.selectedTipePegawai += 1;
            this.scrollToItemTipePegawai();
        },
        scrollToItemTipePegawai() {
            this.$refs.optionsList.scrollTop = this.selectedTipePegawai * this.itemHeight;
        },
        getDataToken() {
            this.$store.state.loadingScreen = true
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.namaLogin = res.data.nama
                }
                this.$store.state.loadingScreen = false
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataToken()
        this.getDataIsHtml()
        this.getDataTampilkan()
        this.getDataIsPushNotification()
        this.getDataPegawai()
        this.backgroundCard('#83a6eb')
        this.getDataPegawai()
        this.getDataUnit('null')
        this.getDataTipePegawai('null')
        let date = this.thisDate
        var month = date.getMonth() + 1
        var day = date.getDate();
        var year = date.getFullYear();

        this.tglCreated = year + "-" + month + "-" + day;
    },
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete .textarea {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}

.cards-message {
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    color: white;
}
.title-message {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
</style>